import { createSelector } from '@reduxjs/toolkit';

import { CUSTOM_BUCKET_ID } from '../../constants';

const selectedMediaSelector = createSelector(
  (state) => state.aiStudio.bucket,
  (state) => state.aiStudio.selectedMediaIndex,
  (bucket, selectedMediaIndex) => bucket?.media[selectedMediaIndex],
);

const isCustomBucketSelector = createSelector(
  (state) => state.aiStudio.bucket,
  (bucket) => bucket?.bucketId === CUSTOM_BUCKET_ID,
);

export { selectedMediaSelector, isCustomBucketSelector };
